import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

@Component({
  selector: 'app-event-submission-instructions-dialog',
  standalone: false,
  templateUrl: './event-submission-instructions-dialog.component.html',
})
export class EventSubmissionInstructionsDialogComponent {
  form = new FormControl('');

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { isPathwayPreferences: boolean; opportunity: Opportunity },
  ) {}
}
